import styled from 'styled-components';
import { motion } from 'framer-motion';

export const StyledAvatar = styled(motion.img)`
  width: 50px;
  height: 50px;
  cursor: pointer;
  border-radius: ${({ borderRadius }) => borderRadius};
`;
